import React, { useRef } from "react";

/* =======================
   Styles
======================= */
import styles from "./OTPInput.module.scss";

const OTPInput = ({ numInputs = 6, onChange }) => {
  const inputsRef = useRef([]);
  const placeholder = "******";

  const handleChange = (value, index) => {
    // Digits only — strip anything else, keep a single character.
    const digit = value.replace(/\D/g, "").slice(0, 1);

    // Enforce the sanitized value on the (uncontrolled) input so letters/
    // symbols never appear in the box.
    if (inputsRef.current[index]) {
      inputsRef.current[index].value = digit;
    }

    // Update the OTP array with the new value at the specific index
    const otpArray = [];
    inputsRef.current.forEach((inp) => otpArray.push(inp.value));

    // Send the updated OTP string to the parent component
    onChange(otpArray.join(""));

    // If the input is filled, move focus to the next input
    if (digit && index < numInputs - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Move to previous input on backspace if the current one is empty
    if (e.key === "Backspace" && !e.target.value && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    // Handle the paste event and distribute the OTP across inputs.
    // Strip non-digits, then take only the first numInputs characters.
    e.preventDefault();
    const pastedOtp = e.clipboardData
      .getData("Text")
      .replace(/\D/g, "")
      .slice(0, numInputs);

    // Set the OTP value for each input field
    pastedOtp.split("").forEach((char, i) => {
      if (inputsRef.current[i]) {
        inputsRef.current[i].value = char;
      }
    });

    // Send the OTP to the parent component
    onChange(pastedOtp);

    // UX Enhancement: Move focus to the last filled input after pasting
    const focusIndex = Math.min(pastedOtp.length, numInputs - 1);
    if (inputsRef.current[focusIndex]) {
      inputsRef.current[focusIndex].focus();
    }
  };

  return (
    <div className={styles["admin-otp-input__wrapper"]}>
      {Array.from({ length: numInputs }).map((_, i) => (
        <input
          key={i}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder={placeholder[i] || ""}
          maxLength="1"
          className={styles["admin-otp-input__field"]}
          onChange={(e) => handleChange(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          ref={(el) => (inputsRef.current[i] = el)}
          onPaste={handlePaste}
        />
      ))}
    </div>
  );
};

export default OTPInput;
